import { File } from '@/common/types/file'
import { LastReview } from '@/common/types/generalInformation.type'
import { RequirementListSummaryData } from '@/common/types/requirementListSummary.type'

export enum MaintenanceFiscalAssessmentEntryStatus {
  AwaitingEstablishmentDocuments = 'awaiting_establishment_documents',
  AwaitingManagementReview = 'awaiting_management_review',
  Completed = 'completed',
}

export type MaintenanceFiscalAssessmentDocumentGroupData = {
  documents: {
    id: string
    file: File
    last_review: LastReview
  }[]
  id: string
  kind: 'activity' | 'piece'
}

export type MaintenanceFiscalAssessmentEntryData = {
  canceled_at: string | null
  completed_at: string | null
  document_groups: MaintenanceFiscalAssessmentDocumentGroupData[]
  id: string
  process_started_at: string
  requirement_list_summary: RequirementListSummaryData
  status: MaintenanceFiscalAssessmentEntryStatus
}
